import { useTranslation } from '@/features/shared/composables/useTranslation'

const t = useTranslation()

export enum EntityTypes {
  BRAND = 1,
  RETAILER = 2,
}

export const entityTypeNames: Record<
  string,
  {
    lowercase: string
    lowercasePlural: string
    capitalized: string
    capitalizedPlural: string
    uppercase: string
    uppercasePlural: string
  }
> = {
  [EntityTypes.BRAND]: {
    lowercase: t('entity_types.brand.lowercase'),
    lowercasePlural: t('entity_types.brand.lowercase', 2),
    capitalized: t('entity_types.brand.capitalized'),
    capitalizedPlural: t('entity_types.brand.capitalized', 2),
    uppercase: t('entity_types.brand.uppercase'),
    uppercasePlural: t('entity_types.brand.uppercase', 2),
  },
  [EntityTypes.RETAILER]: {
    lowercase: t('entity_types.retailer.lowercase'),
    lowercasePlural: t('entity_types.retailer.lowercase', 2),
    capitalized: t('entity_types.retailer.capitalized'),
    capitalizedPlural: t('entity_types.retailer.capitalized', 2),
    uppercase: t('entity_types.retailer.uppercase'),
    uppercasePlural: t('entity_types.retailer.uppercase', 2),
  },
}
